import BrowserLanguage from 'in-browser-language'
import Cookies from 'js-cookie'
import _ from 'lodash'
import Settings from '@/config/Settings'

// Cookies.remove(Settings.cookies.lang)

let defaultLanguage = Cookies.get(Settings.cookies.lang) || BrowserLanguage.pick(Settings.locale, _.head(Settings.locale))

_.each(Settings.onfWebsite, type => {
  _.each(type, (langUrl, lang) => {
    console.log(window.location.hostname, langUrl)
    if(window.location.hostname == langUrl)
      defaultLanguage = lang
  })
})

export default defaultLanguage
